import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ExternalMenuItem } from '../../../../core-module/models/menu-item';
import { UserRole } from '../../../../core-module/models/role';
import { RoleBaseComponent } from '../../../../shared-module/components/role-base.component';
import { MenuHelperService } from '../../../../shared-module/services/menu-helper.service';
import { Permissions } from '../../../../core-module/constants/permission.constants';

@Component({
  selector: '[app-external-main-nav-menu], app-external-main-nav-menu',
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './external-main-nav-menu.component.html',
  styleUrl: './external-main-nav-menu.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ExternalMainNavMenuComponent extends RoleBaseComponent {

  // Signal-based state
  private rawMenuItems = signal<ExternalMenuItem[]>([]);

  // Computed signals
  menuItems = computed(() => {
    const items = this.rawMenuItems();
    return this.menuHelperService.filterAccessibleItems(items);
  });

  SCL_EXTERNAL_ROLES = [UserRole.ReferralPartner, UserRole.VirtualAssistant]

  EXTERNAL_MARKETING_ACCESS = {
    roles: this.SCL_EXTERNAL_ROLES,
    permissions: [Permissions.MarketingHub.MarketingResource.Read]
  }

  EXTERNAL_PARTNER_ACCESS = {
      roles: this.SCL_EXTERNAL_ROLES,
      permissions: []
  }

  constructor(
    private menuHelperService: MenuHelperService
  ) {
    super();

    // Effect to watch for token changes and update menu items
    effect(() => {
      // Access token to make effect reactive to auth changes
      const roles = this.accountService.getRoles();
      const items = this.getItems(roles);
      this.rawMenuItems.set(items);
    });
  }
  private getItems(roles: UserRole[]): ExternalMenuItem[] {
    let items: ExternalMenuItem[] = [
      {
        id: 1,
        name: 'Home',
        isActive: true,
        navCommands: ['/home'],
        ...this.EXTERNAL_PARTNER_ACCESS,
        order: 1
      },
      {
        id: 2,
        name: 'Graphics',
        isActive: false,
        navCommands: ['/marketing/graphics'],
        ...this.EXTERNAL_MARKETING_ACCESS,
        order: 1
      },
      {
        id: 3,
        name: 'Flyers',
        isActive: false,
        navCommands: ['/marketing/flyers'],
        ...this.EXTERNAL_MARKETING_ACCESS,
        order: 1
      },
      {
        id: 4,
        name: 'Calculators',
        isActive: false,
        navCommands: ['/cal'],
        roles: this.SCL_EXTERNAL_ROLES,
        permissions: [Permissions.Calculator.IncomeCalculator.Read, Permissions.Calculator.SaleCalculator.Read, Permissions.Calculator.CalculatorScenario.Read],
        order: 1
      },
      {
        id: 5,
        name: 'Profile',
        isActive: false,
        navCommands: ['/account'],
        ...this.EXTERNAL_PARTNER_ACCESS,
        order: 1
      }
    ];

    return items;
  }

}
